import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IListItemProps = IContainerProps & {
  children: React.ReactNode;
};

const styles = stylex.create({
  host: {
    marginLeft: '1rem',
  },
});

export const ListItem: React.FC<IListItemProps> = (props) => {
  const { sx, children } = props;

  return <li {...stylex.props(styles.host, sx)}>{children}</li>;
};
